import React from 'react';
import "./success.css";
import Pic from "../../img/success.png"

const Success = () => {
  return <div className='notify'>
    <div>APPROVED</div>
    <img src={Pic} alt='success-icon' />
  </div>;
};

export default Success;
